import { makeAutoObservable, runInAction } from "mobx";
import {
  readLicenseCalculatorWidgetEnabled,
  writeLicenseCalculatorWidgetEnabled,
} from "../utils/licenseCalculatorStorage";

class LicenseCalculatorWidgetStore {
  enabled = readLicenseCalculatorWidgetEnabled();

  constructor() {
    makeAutoObservable(this);
  }

  setEnabled = (value) => {
    runInAction(() => {
      this.enabled = value;
      writeLicenseCalculatorWidgetEnabled(value);
    });
  };
}

const LicenseCalculatorWidget = new LicenseCalculatorWidgetStore();

export default LicenseCalculatorWidget;
